var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"h4"},[_vm._v(" "+_vm._s(_vm.$t('dialogs.concept.dontWorryItsEasy'))+" ")]),_c('ib-button',{staticClass:"button text-uppercase py-3",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }